import {
  Upload,
  PenLine,
  Sparkles,
  Type,
  ImagePlus,
  Film,
  Images,
  MessageSquare,
  RefreshCw,
} from "lucide-react";
import type { HowItWorksStep, FlowId } from "./types";

export const FLOW_STEPS: Record<FlowId, HowItWorksStep[]> = {
  imageGenerator: [
    {
      iconComponent: Upload,
      titleKey: "step1Title",
      descKey: "step1Desc",
    },
    {
      iconComponent: PenLine,
      titleKey: "step2Title",
      descKey: "step2Desc",
    },
    {
      iconComponent: Sparkles,
      titleKey: "step3Title",
      descKey: "step3Desc",
    },
  ],
  textToVideo: [
    {
      iconComponent: Type,
      titleKey: "step1Title",
      descKey: "step1Desc",
    },
    {
      iconComponent: ImagePlus,
      titleKey: "step2Title",
      descKey: "step2Desc",
    },
    {
      iconComponent: Film,
      titleKey: "step3Title",
      descKey: "step3Desc",
    },
  ],
  framesToVideo: [
    {
      iconComponent: Images,
      titleKey: "step1Title",
      descKey: "step1Desc",
    },
    {
      iconComponent: PenLine,
      titleKey: "step2Title",
      descKey: "step2Desc",
    },
    {
      iconComponent: Film,
      titleKey: "step3Title",
      descKey: "step3Desc",
    },
  ],
  productCatalog: [
    {
      iconComponent: Upload,
      titleKey: "step1Title",
      descKey: "step1Desc",
    },
    {
      iconComponent: Sparkles,
      titleKey: "step2Title",
      descKey: "step2Desc",
    },
  ],
  directorChat: [
    {
      iconComponent: MessageSquare,
      titleKey: "step1Title",
      descKey: "step1Desc",
    },
    {
      iconComponent: Sparkles,
      titleKey: "step2Title",
      descKey: "step2Desc",
    },
    {
      iconComponent: RefreshCw,
      titleKey: "step3Title",
      descKey: "step3Desc",
    },
  ],
};
